import React, { useState, useEffect, useCallback } from "react";
import { Box } from "@material-ui/core";
import { useDataUpload } from "../../../../hooks/useDataUpload";
import { useStyles } from "./styles";
import Attachment from './Attachment'
import FileInput from './FileInput'
import {useFiles } from '../../../../hooks/useFiles'
import { deleteAttachment } from '../../../../functions/api/customer-page' // adjust import path

const Attachments = (props) => {
    const { closeHandler, customerId, customerName, orderId, showFileInput } = props;
    const classes = useStyles();

    const [filesList, setFilesList] = useFiles(customerId)

    const deleteFileHandler = useCallback((fileId) => async () => {
        const response = await deleteAttachment(customerId, fileId)
        const files = response?.result?.attachments || []
        setFilesList(files)
    }, [customerId])

    return (
        <div style={{ display: 'block', padding: '10px' }}>
            {showFileInput && (<FileInput 
                customerName = {customerName}
                customerId = {customerId}
                orderId= {orderId}
                updateFilesList = {setFilesList}/> )}
            <Box
                container={"true"}
                p={3}
                className={classes.filesHolder}
            >
                {filesList?.map?.((i) => (
                    <Attachment 
                        key={i._id} 
                        element={i}
                        onDelete={deleteFileHandler(i._id)}
                    />
                ))}
            </Box>
            <Box
                container={"true"}
                p={3}
                className={classes.backLinkWrapper}
            >
                <p
                    onClick={closeHandler}
                    className={classes.backLink}
                >
                    חזרה למערכות
        </p>
            </Box>
        </div>
    );
};

export default Attachments

